import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MensagensService {

  private http = inject(HttpClient);
  private baseUrl = environment.apiUrl;
  private notificacoes = "notificacoes";
  private visualizar = 'visualizar';


  //--- Lista de mensagens não lidas
  listarMensagensNaoLidas(): Observable<any> {
    // console.log('Lista Mensagens não lidas do usuario: ', {});
    return this.http.get<any[]>(`${this.baseUrl}/${this.notificacoes}`);
  }
  

  //--- Busca mensagem específica
  buscaMensagenEspecifica(id: number): Observable<any> {
    // console.log('Buscando Mensagens por ID:', id);
    return this.http.get<any>(`${this.baseUrl}/${this.notificacoes}/${this.visualizar}/${id}`);
  }



}